<template>
    <header class="auth-layout__header">
        <div class="auth-layout__container">
            <div class="auth-header">
                <img
                    src="@/assets/icons/logo-big.svg"
                    class="auth-header__logo"
                    @click="goToLandingPage"
                />

                <div v-if="!isLoggedIn" class="auth-header__actions">
                    <button
                        :class="[
                            'auth-header__button',
                            {
                                'active': isRegisterPage,
                            },
                        ]"
                        @click="goToRegisterPage"
                    >
                        Регистрация
                    </button>

                    <button
                        :class="[
                            'auth-header__button',
                            {
                                'active': isLoginPage,
                            },
                        ]"
                        @click="goToLoginPage"
                    >
                        Войти
                    </button>
                </div>
            </div>
        </div>
    </header>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import { useRouter, useRoute } from 'vue-router';
    import { useStorage } from 'vue3-storage';

    const router = useRouter();
    const route = useRoute();
    const $storage = useStorage();

    // есть редирект для аутентифицированных пользователей
    // но пусть будет на всякий случай
    const isLoggedIn = computed(() => {
        return !!$storage.getStorageSync('token');
    });

    const isLoginPage = route.name === 'Login';
    const isRegisterPage = route.name === 'Register';

    function goToLandingPage(): void {
        router.push({ name: 'Landing' });
    }

    function goToRegisterPage(): void {
        router.push({ name: 'Register' });
    }

    function goToLoginPage(): void {
        router.push({ name: 'Login' });
    }
</script>

<style scoped lang="scss">
    @use './AuthHeader.scss' as *;
</style>
